import { Button, EasyPopover, Icon } from "@tm/components"
import { ERIKContentService } from "@tm/data"
import FileShare from "../fileShare/FileShare"

type Props = {
    selectedFiles: ERIKContentService.FileMeta[]
}

export function FileSharePopUp({ selectedFiles }: Props) {
    return (
        <EasyPopover anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ horizontal: "right", vertical: "top" }}>
            <EasyPopover.ActionButton>
                <Button startIcon={<Icon name="share" />} />
            </EasyPopover.ActionButton>
            <EasyPopover.Content sx={{ padding: "1em" }}>
                <FileShare files={selectedFiles} />
            </EasyPopover.Content>
        </EasyPopover>
    )
}
